import { Loader } from 'src/design/atoms/Loader';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useOfficeDetail } from 'src/api/queries/organization/useOfficeDetail';
import { Header } from 'src/design/organisms/Header';
import { OfficeForm } from 'src/routes/Settings/Offices/components/OfficeForm';

export const UpdateOffice: React.FC = () => {
  const params = useParams<{ id: string }>();
  const { data: office, isLoading: loading } = useOfficeDetail(
    Number(params.id),
  );

  const officeTitle = loading ? 'Loading...' : office?.name || params.id;

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Offices', href: '/settings/offices' },
            { text: officeTitle ?? '' },
          ],
        }}
        title={officeTitle ?? ''}
        helpText="Update this office's divisions, modules, workflows, and daily settings."
      />
      {loading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : office ? (
        <OfficeForm initialValues={office} />
      ) : (
        <Text c="dimmed">Office not found.</Text>
      )}
    </>
  );
};
